// extracted by mini-css-extract-plugin
export default {"root":"EntityUpload_root__dRWRW","example":"EntityUpload_example__Cb7uq","form":"EntityUpload_form__qrs3o"};